module.exports = __webpack_public_path__ + "assets/img/favicon/favicon.9729efe67411f396d486e49e2811460f.ico";